/** Strings of the work-item bulk bar, manager override panel, workflow action bar, row actions and slot picker: `wiBulkEn` is the source, `wiBulkCs` must have the same keys. */
export const wiBulkEn = {
  wiBulk: {
    itemNoun: "work item",
    itemNounPlural: "work items",
    assignee: "Assignee",
    priority: "Priority",
    release: "Release",
    move: "Move",
    team: "Team",
    delete: "Delete",
    cancel: "Cancel",
    apply: "Apply",
    working: "Working",
    error: "Error",
    sendToExistingReport: "Send to existing report",
    createReport: "Create report",
    reportCreated: "Report created",
    reportFailed: "Couldn't create report",
    appliedPartial: "Applied to {{done}} of {{total}}",
    deleted_one: "Deleted {{count}} work item",
    deleted_few: "Deleted {{count}} work items",
    deleted_many: "Deleted {{count}} work items",
    deleted_other: "Deleted {{count}} work items",
    updated_one: "Updated {{count}} work item",
    updated_few: "Updated {{count}} work items",
    updated_many: "Updated {{count}} work items",
    updated_other: "Updated {{count}} work items",
    statusSet_one: "Status set on {{count}} work item",
    statusSet_few: "Status set on {{count}} work items",
    statusSet_many: "Status set on {{count}} work items",
    statusSet_other: "Status set on {{count}} work items",
    moveApplied_one: "{{label}} applied to {{count}} work item",
    moveApplied_few: "{{label}} applied to {{count}} work items",
    moveApplied_many: "{{label}} applied to {{count}} work items",
    moveApplied_other: "{{label}} applied to {{count}} work items",
    bulkFailed: "Bulk action failed",
    overrideFailed: "Status override failed",
    moveFailed: "Bulk move failed",
    titles: {
      assignee: "Change Assignee",
      priority: "Change Priority",
      release: "Assign to Release",
      team: "Set Team Member",
      delete: "Delete Work Items",
      move: "Move Work Items",
    },
    confirmDelete_one:
      "Are you sure you want to permanently delete {{count}} work item? The GitLab issues are deleted too. This cannot be undone.",
    confirmDelete_few:
      "Are you sure you want to permanently delete {{count}} work items? The GitLab issues are deleted too. This cannot be undone.",
    confirmDelete_many:
      "Are you sure you want to permanently delete {{count}} work items? The GitLab issues are deleted too. This cannot be undone.",
    confirmDelete_other:
      "Are you sure you want to permanently delete {{count}} work items? The GitLab issues are deleted too. This cannot be undone.",
    action: "Action",
    select: "— select —",
    none: "— none —",
    selectRelease: "— select release —",
    noUsers: "No users",
    noOpenReleases: "No open releases",
    statusOverride: "Status override (manager)",
    statusOverrideHint:
      "Sets the state directly, skipping the path the workflow would take. A row whose workflow can't reach it is named in the result.",
    checking: "Checking what would block this…",
    canMove: "{{ready}} of {{total}} can move. Fix these first:",
    blocker_one: "{{count}} ticket: {{reason}}",
    blocker_few: "{{count}} tickets: {{reason}}",
    blocker_many: "{{count}} tickets: {{reason}}",
    blocker_other: "{{count}} tickets: {{reason}}",
    blockerAll_one: "All {{count}} ticket: {{reason}}",
    blockerAll_few: "All {{count}} tickets: {{reason}}",
    blockerAll_many: "All {{count}} tickets: {{reason}}",
    blockerAll_other: "All {{count}} tickets: {{reason}}",
    slotGap_one: "{{label}} ({{count}} ticket)",
    slotGap_few: "{{label}} ({{count}} tickets)",
    slotGap_many: "{{label}} ({{count}} tickets)",
    slotGap_other: "{{label}} ({{count}} tickets)",
    estimatedHours: "Estimated hours",
    comment: "Comment",
    optional: "(optional)",
    notePlaceholder: "Add a note…",
    teamSlot: "Team slot",
    assignTo: "Assign to",
    newPriority: "New priority",
    user: "User",
    priorities: {
      low: "Low",
      normal: "Normal",
      high: "High",
      urgent: "Urgent",
    },
    slots: {
      manager: "Manager",
      developer: "Developer",
      tester: "Tester",
      maintainer: "Maintainer",
      productionTester: "Production tester",
      productionMaintainer: "Production maintainer",
      managerId: "Manager",
      developerId: "Developer",
      testerId: "Tester",
      maintainerId: "Maintainer",
      productionTesterId: "Production tester",
      productionMaintainerId: "Production maintainer",
    },
  },
  wiManager: {
    statusOverride: "Status override",
    pickState: "Pick a state…",
    apply: "Apply",
    convertAria: "Convert work item",
    convert: "Convert…",
    toFeature: "to feature",
    toBug: "to bug",
    toTask: "to task",
    toHotfix: "to hotfix…",
    toIdea: "to idea",
    toProject: "to another project…",
    deleteWi: "Delete work item",
    requestFailed: "Request failed",
    statusUpdated: "Status updated",
    statusFailed: "Status override failed",
    noActionTargets: 'No action targets state "{{state}}".',
    deleteFailed: "Delete failed",
    moved: "Work item moved",
    moveFailed: "Move failed",
    convertIdeaFailed: "Convert to idea failed",
    convertedTo: "Converted to {{type}}",
    types: {
      feature: "feature",
      bug: "bug",
      task: "task",
      hotfix: "hotfix",
    },
    convertFailed: "Convert failed",
    titles: {
      delete: "Delete work item?",
      moveToProject: "Move to another project?",
      convertToHotfix: "Convert to hotfix?",
      convertToIdea: "Convert to idea?",
    },
    descriptions: {
      delete:
        "The GitLab issue will be deleted and any logged time on this work item will be re-attributed to project overhead. This cannot be undone.",
      moveToProject:
        "The GitLab issue moves to the chosen project (GitLab assigns it a new number). Every time entry on this work item follows it. Release and category are cleared because they live on the source project.",
      convertToHotfix:
        "The GitLab issue type switches to incident and the work item moves onto the minimal hotfix workflow (triage → in progress → done).",
      convertToIdea:
        "A new idea will be created from this work item's title and description, the GitLab issue will be deleted, and any logged time will be re-attributed to project overhead. This cannot be undone.",
    },
    destinationProject: "Destination project",
    pickProject: "— pick a project —",
    noEligibleProjects: "No eligible projects",
    cancel: "Cancel",
    buttons: {
      delete: "Delete",
      moveToProject: "Move",
      convert: "Convert",
    },
  },
  wiActionBar: {
    actionCompleted: "Action completed",
    actionFailed: "Action failed",
    error: "Error",
    statusArrow: "Status → {{state}}",
    commentRequired: "Comment required",
    commentRequiredHint: '"{{label}}" needs a reason — fill in the comment first.',
    blocked: "BLOCKED",
    waitingOnClient: "WAITING ON CLIENT",
    cancelled: "CANCELLED",
    assignee: "Assignee",
    selectMember: "— select member —",
    noMembers: "No project members",
    me: "{{name}} (me)",
    unnamed: "(unnamed)",
    estimatedHours: "Estimated hours",
    comment: "Comment",
    optional: "(optional)",
    notePlaceholder: "Add a note for the developer…",
    cancel: "Cancel",
    justDone: "Done: {{label}} → {{state}}",
    confirmTitle: "{{label}}?",
    confirmNotAssignee:
      "The ticket is assigned to {{assignee}}, not to you. This moves it on in their place. Go ahead?",
    confirmNobody: "Nobody holds this ticket. This moves it on. Go ahead?",
    confirm: "Yes, {{label}}",
  },
  wiRow: {
    actionCompleted: "Action completed",
    actionFailed: "Action failed",
    error: "Error",
    statusArrow: "Status → {{state}}",
    estimatedHours: "Estimated hours",
    comment: "Comment",
    optional: "(optional)",
    notePlaceholder: "Add a note…",
    cancel: "Cancel",
  },
  wiSlot: {
    nobody: "Nobody is in this slot yet and the next step needs them.",
    loading: "Loading…",
    selectMember: "— select member —",
    noMemberHoldsRole: "No member holds this role",
    whoTakesNext: "Who takes it next?",
    cancel: "Cancel",
    continue: "Continue",
  },
};

export const wiBulkCs: typeof wiBulkEn = {
  wiBulk: {
    itemNoun: "tiket",
    itemNounPlural: "tiketů",
    assignee: "Řešitel",
    priority: "Priorita",
    release: "Release",
    move: "Posunout",
    team: "Tým",
    delete: "Smazat",
    cancel: "Zrušit",
    apply: "Použít",
    working: "Pracuji",
    error: "Chyba",
    sendToExistingReport: "Přidat do existujícího výkazu",
    createReport: "Vytvořit výkaz",
    reportCreated: "Výkaz vytvořen",
    reportFailed: "Výkaz se nepodařilo vytvořit",
    appliedPartial: "Použito u {{done}} z {{total}}",
    deleted_one: "Smazán {{count}} tiket",
    deleted_few: "Smazány {{count}} tikety",
    deleted_many: "Smazáno {{count}} tiketů",
    deleted_other: "Smazáno {{count}} tiketů",
    updated_one: "Upraven {{count}} tiket",
    updated_few: "Upraveny {{count}} tikety",
    updated_many: "Upraveno {{count}} tiketů",
    updated_other: "Upraveno {{count}} tiketů",
    statusSet_one: "Stav nastaven u {{count}} tiketu",
    statusSet_few: "Stav nastaven u {{count}} tiketů",
    statusSet_many: "Stav nastaven u {{count}} tiketů",
    statusSet_other: "Stav nastaven u {{count}} tiketů",
    moveApplied_one: "{{label}}: provedeno u {{count}} tiketu",
    moveApplied_few: "{{label}}: provedeno u {{count}} tiketů",
    moveApplied_many: "{{label}}: provedeno u {{count}} tiketů",
    moveApplied_other: "{{label}}: provedeno u {{count}} tiketů",
    bulkFailed: "Hromadná akce selhala",
    overrideFailed: "Vynucení stavu selhalo",
    moveFailed: "Hromadný posun selhal",
    titles: {
      assignee: "Změnit řešitele",
      priority: "Změnit prioritu",
      release: "Přiřadit k release",
      team: "Nastavit člena týmu",
      delete: "Smazat tikety",
      move: "Posunout tikety",
    },
    confirmDelete_one:
      "Opravdu chcete trvale smazat {{count}} tiket? Smažou se i issues v GitLabu. Tuto akci nelze vrátit.",
    confirmDelete_few:
      "Opravdu chcete trvale smazat {{count}} tikety? Smažou se i issues v GitLabu. Tuto akci nelze vrátit.",
    confirmDelete_many:
      "Opravdu chcete trvale smazat {{count}} tiketů? Smažou se i issues v GitLabu. Tuto akci nelze vrátit.",
    confirmDelete_other:
      "Opravdu chcete trvale smazat {{count}} tiketů? Smažou se i issues v GitLabu. Tuto akci nelze vrátit.",
    action: "Akce",
    select: "— vyberte —",
    none: "— žádný —",
    selectRelease: "— vyberte release —",
    noUsers: "Žádní uživatelé",
    noOpenReleases: "Žádné otevřené release",
    statusOverride: "Vynucení stavu (manažer)",
    statusOverrideHint:
      "Nastaví stav přímo a přeskočí cestu, kterou by šel workflow. Tikety, kterým workflow do tohoto stavu cestu nedovolí, budou jmenovány ve výsledku.",
    checking: "Zjišťuji, co by to blokovalo…",
    canMove: "{{ready}} z {{total}} lze posunout. Nejdřív opravte tohle:",
    blocker_one: "{{count}} tiket: {{reason}}",
    blocker_few: "{{count}} tikety: {{reason}}",
    blocker_many: "{{count}} tiketů: {{reason}}",
    blocker_other: "{{count}} tiketů: {{reason}}",
    blockerAll_one: "Všechny ({{count}}) tiket: {{reason}}",
    blockerAll_few: "Všechny ({{count}}) tikety: {{reason}}",
    blockerAll_many: "Všech {{count}} tiketů: {{reason}}",
    blockerAll_other: "Všech {{count}} tiketů: {{reason}}",
    slotGap_one: "{{label}} ({{count}} tiket)",
    slotGap_few: "{{label}} ({{count}} tikety)",
    slotGap_many: "{{label}} ({{count}} tiketů)",
    slotGap_other: "{{label}} ({{count}} tiketů)",
    estimatedHours: "Odhadované hodiny",
    comment: "Komentář",
    optional: "(nepovinný)",
    notePlaceholder: "Přidejte poznámku…",
    teamSlot: "Role v týmu",
    assignTo: "Přiřadit komu",
    newPriority: "Nová priorita",
    user: "Uživatel",
    priorities: {
      low: "Nízká",
      normal: "Normální",
      high: "Vysoká",
      urgent: "Naléhavá",
    },
    slots: {
      manager: "Manažer",
      developer: "Vývojář",
      tester: "Tester",
      maintainer: "Správce",
      productionTester: "Produkční tester",
      productionMaintainer: "Produkční správce",
      managerId: "Manažer",
      developerId: "Vývojář",
      testerId: "Tester",
      maintainerId: "Správce",
      productionTesterId: "Produkční tester",
      productionMaintainerId: "Produkční správce",
    },
  },
  wiManager: {
    statusOverride: "Vynucení stavu",
    pickState: "Vyberte stav…",
    apply: "Použít",
    convertAria: "Převést tiket",
    convert: "Převést…",
    toFeature: "na featuru",
    toBug: "na bug",
    toTask: "na úkol",
    toHotfix: "na hotfix…",
    toIdea: "na nápad",
    toProject: "do jiného projektu…",
    deleteWi: "Smazat tiket",
    requestFailed: "Požadavek selhal",
    statusUpdated: "Stav změněn",
    statusFailed: "Vynucení stavu selhalo",
    noActionTargets: "Žádná akce nevede do stavu „{{state}}“.",
    deleteFailed: "Smazání selhalo",
    moved: "Tiket přesunut",
    moveFailed: "Přesun selhal",
    convertIdeaFailed: "Převod na nápad selhal",
    convertedTo: "Převedeno na: {{type}}",
    types: {
      feature: "featura",
      bug: "bug",
      task: "úkol",
      hotfix: "hotfix",
    },
    convertFailed: "Převod selhal",
    titles: {
      delete: "Smazat tiket?",
      moveToProject: "Přesunout do jiného projektu?",
      convertToHotfix: "Převést na hotfix?",
      convertToIdea: "Převést na nápad?",
    },
    descriptions: {
      delete:
        "Issue v GitLabu bude smazáno a všechen vykázaný čas na tomto tiketu se přepíše na režii projektu. Tuto akci nelze vrátit.",
      moveToProject:
        "Issue v GitLabu se přesune do vybraného projektu (GitLab mu přidělí nové číslo). Všechny časové záznamy tohoto tiketu se přesunou s ním. Release a kategorie se smažou, protože patří zdrojovému projektu.",
      convertToHotfix:
        "Typ issue v GitLabu se změní na incident a tiket přejde na minimální hotfix workflow (třídění → rozpracováno → hotovo).",
      convertToIdea:
        "Z názvu a popisu tohoto tiketu vznikne nový nápad, issue v GitLabu bude smazáno a všechen vykázaný čas se přepíše na režii projektu. Tuto akci nelze vrátit.",
    },
    destinationProject: "Cílový projekt",
    pickProject: "— vyberte projekt —",
    noEligibleProjects: "Žádné vhodné projekty",
    cancel: "Zrušit",
    buttons: {
      delete: "Smazat",
      moveToProject: "Přesunout",
      convert: "Převést",
    },
  },
  wiActionBar: {
    actionCompleted: "Akce provedena",
    actionFailed: "Akce selhala",
    error: "Chyba",
    statusArrow: "Stav → {{state}}",
    commentRequired: "Komentář je povinný",
    commentRequiredHint: "Akce „{{label}}“ vyžaduje důvod — nejdřív vyplňte komentář.",
    blocked: "BLOKOVÁNO",
    waitingOnClient: "ČEKÁ NA KLIENTA",
    cancelled: "ZRUŠENO",
    assignee: "Řešitel",
    selectMember: "— vyberte člena —",
    noMembers: "Žádní členové projektu",
    me: "{{name}} (já)",
    unnamed: "(bez jména)",
    estimatedHours: "Odhadované hodiny",
    comment: "Komentář",
    optional: "(nepovinný)",
    notePlaceholder: "Přidejte poznámku pro vývojáře…",
    cancel: "Zrušit",
    justDone: "Hotovo: {{label}} → {{state}}",
    confirmTitle: "{{label}}?",
    confirmNotAssignee:
      "Tiket má na sobě {{assignee}}, ne ty. Posuneš ho dál místo něj. Pokračovat?",
    confirmNobody: "Tiket nemá nikdo na sobě. Posuneš ho dál. Pokračovat?",
    confirm: "Ano, {{label}}",
  },
  wiRow: {
    actionCompleted: "Akce provedena",
    actionFailed: "Akce selhala",
    error: "Chyba",
    statusArrow: "Stav → {{state}}",
    estimatedHours: "Odhadované hodiny",
    comment: "Komentář",
    optional: "(nepovinný)",
    notePlaceholder: "Přidejte poznámku…",
    cancel: "Zrušit",
  },
  wiSlot: {
    nobody: "V této roli zatím nikdo není a další krok ho potřebuje.",
    loading: "Načítám…",
    selectMember: "— vyberte člena —",
    noMemberHoldsRole: "Tuto roli nemá žádný člen",
    whoTakesNext: "Kdo to převezme dál?",
    cancel: "Zrušit",
    continue: "Pokračovat",
  },
};
